module.exports = __webpack_public_path__ + "img/East_Dunbartonshire.3d742569.png";